import React, { Component } from 'react'
import {    
    Button,
    Card,
    CardBody,
    CardHeader,
    ListGroup,
    ListGroupItem,
    Row,
    Col,
    Container,
    Progress,
    Popover,
    PopoverBody,
    Collapse
  } from 'reactstrap';
import { MONSTERS } from "../lib/monsters/index";
import monsterImagesList from '../lib/monsterImages/monsterImagesList';
import { MOVEMENT, ATTACK, RANGE, iconForStat } from "../lib/stats";
import { getIcon } from "../lib/icons";
import './MonsterContainer.css';
import StatusPopover from './StatusPopover';
import { Fade } from 'react-reveal';

// console.log(MONSTERS["Harrower Infester"].stats[5].elite.extra);

class MonsterContainer extends Component {
    constructor(props) {
        super(props);
        // console.log(this.props);
        this.state = {

            maxHP:[MONSTERS[this.props.monsterType].stats[this.props.level].normal.maxHP,MONSTERS[this.props.monsterType].stats[this.props.level].elite.maxHP],
            move:[MONSTERS[this.props.monsterType].stats[this.props.level].normal.move,MONSTERS[this.props.monsterType].stats[this.props.level].elite.move],
            range:[MONSTERS[this.props.monsterType].stats[this.props.level].normal.range,MONSTERS[this.props.monsterType].stats[this.props.level].elite.range],
            attack:[MONSTERS[this.props.monsterType].stats[this.props.level].normal.attack,MONSTERS[this.props.monsterType].stats[this.props.level].elite.attack],
            extra:[MONSTERS[this.props.monsterType].stats[this.props.level].normal.extra,MONSTERS[this.props.monsterType].stats[this.props.level].elite.extra],
            tokenCount:MONSTERS[this.props.monsterType].tokenCount,

            monsterList:[],
            removePopoverOpen:false,
            collapseOpen:true

            
        };

        this.toggleStatus = this.toggleStatus.bind(this);
        this.clearStatuses = this.clearStatuses.bind(this);
        this.togglePopover = this.togglePopover.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);

      }

    componentWillMount() {
        for(let j=0;j<2;j++){
            if(this.state.range[j] === 0){
                let range = this.state.range;
                range[j]="-";
                this.setState({range:range});
            }
            if(this.state.attack[j] === 0){
                let attack = this.state.attack;
                attack[j]="-";
                this.setState({attack:attack});
            }
            if(this.state.move[j] === 0){
                let move = this.state.move;
                move[j]="-"
                this.setState({move:move});
            }
        }
        
        let monsterList = [];
        for(let i=1;i<=this.state.tokenCount;i++){
            
            monsterList.push( {
                "number":i,
                "active":false,
                "maxHP":this.state.maxHP[0],
                "currentHP":this.state.maxHP[0],
                "statuses":{
                    "disarm":false,
                    "immobilize":false,
                    "wound":false,
                    "muddle":false,
                    "poison":false,
                    "stun":false,
                    "invisible":false,
                    "strengthen":false
                },
                "rank":"normal"
            })
        }
        // console.log(monsterList);
        this.setState({monsterList:monsterList});

    }

    togglePopover() {
        this.setState({
            removePopoverOpen: !this.state.removePopoverOpen
        });
    }

    toggleCollapse() {
        this.setState({ collapseOpen: !this.state.collapseOpen });
    }

    toggleActive = (monsterNumber) => {
        let newMonsterList = this.state.monsterList;
        
        //reset for new monster
        if(!newMonsterList[monsterNumber-1].active){
            newMonsterList[monsterNumber-1].currentHP = newMonsterList[monsterNumber-1].maxHP;
            newMonsterList[monsterNumber-1].rank = "normal";
            newMonsterList[monsterNumber - 1].statuses = {
                "disarm": false,
                "immobilize": false,
                "wound": false,
                "muddle": false,
                "poison": false,
                "stun": false,
                "invisible": false,
                "strengthen": false
            };
        }

        newMonsterList[monsterNumber-1].active = !newMonsterList[monsterNumber-1].active;
        this.setState({monsterList:newMonsterList});
        // console.log(this.props.monsterType + " " + monsterNumber + " set to " + newMonsterList[monsterNumber-1].active)
    }

    toggleRank = (monsterNumber) => {
        let newMonsterList = this.state.monsterList;
        if(newMonsterList[monsterNumber-1].rank === "normal"){
            newMonsterList[monsterNumber-1].rank = "elite";
            newMonsterList[monsterNumber-1].maxHP = this.state.maxHP[1];
            newMonsterList[monsterNumber-1].currentHP = newMonsterList[monsterNumber-1].maxHP;
        } else {
            newMonsterList[monsterNumber - 1].rank = "normal";
            newMonsterList[monsterNumber - 1].maxHP = this.state.maxHP[0];
            newMonsterList[monsterNumber - 1].currentHP = newMonsterList[monsterNumber - 1].maxHP;            
        }
        this.setState({monsterList:newMonsterList});
        console.log(this.props.monsterType + " " + monsterNumber + " set to " + newMonsterList[monsterNumber - 1].rank);
    }

    toggleStatus = (monsterNumber,status) => {
        let newMonsterList = this.state.monsterList;
        newMonsterList[monsterNumber-1].statuses[status] = !newMonsterList[monsterNumber-1].statuses[status];
        this.setState({monsterList:newMonsterList});
        console.log("set " + this.props.monsterType + " " + monsterNumber + " " + status + " to " + newMonsterList[monsterNumber-1].statuses[status]);
    }

    killMonster = (monsterNumber) => {
        let newMonsterList = this.state.monsterList;
        newMonsterList[monsterNumber-1].currentHP = 0;
        newMonsterList[monsterNumber-1].active = false;
        this.setState({monsterList:newMonsterList});
        console.log("killed " + this.props.monsterType + " " + monsterNumber);
    }

    changeHP = (monsterNumber,hpChange) => {
        let newMonsterList = this.state.monsterList;
        newMonsterList[monsterNumber-1].currentHP += hpChange;
        if(newMonsterList[monsterNumber-1].currentHP >= newMonsterList[monsterNumber-1].maxHP){
            newMonsterList[monsterNumber-1].currentHP = newMonsterList[monsterNumber-1].maxHP;
        }
        if (newMonsterList[monsterNumber - 1].currentHP < 0) {
            newMonsterList[monsterNumber - 1].currentHP = 0;
        }

        this.setState({monsterList:newMonsterList});
    }

    clearStatuses = (monsterNumber) => {
        let newMonsterList = this.state.monsterList;
        newMonsterList[monsterNumber - 1].statuses = {
            "disarm": false,
            "immobilize": false,
            "wound": false,
            "muddle": false,
            "poison": false,
            "stun": false,
            "invisible": false,
            "strengthen": false
        };
        this.setState({monsterList:newMonsterList});
    }




    render() {
        const statsStyle={
            color:"#ffffff",
            backgroundColor:"#0F0F0F",
            borderColor:"#1b1e21"
        }
        const statsStyleElite={
            color:"#ffffff",
            backgroundColor:"#757303",
            borderColor:"#1b1e21"
        }
        


        return (
            <div>
                <Card className="text-white bg-dark">
                    
                    <CardHeader style={{fontFamily:"PirataOne"}} >
                        <Row>
                            <Col md="4">
                                <h4>
                                    <img className="img-fluid rounded" style={{ height: "30px", width: "30px", cursor:"pointer"}} id={"thumbnail-" + this.props.monsterType.replace(/\s+/g, '')} src={monsterImagesList[this.props.monsterType]} alt={this.props.monsterType} onClick={this.toggleCollapse} /> &nbsp;&nbsp;{this.props.monsterType} : {this.props.level}
                                </h4>

                            </Col>
                            <Col md="4" sm="3">
                                <Row>
                                {
                                    !this.state.collapseOpen ? 
                                        <Fade bottom duration={300}>
                                        <div style={statsStyle}>
                                                &nbsp; HP: <b>{this.state.maxHP[0]}</b>, &nbsp;
                                                <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(ATTACK)} alt="attack" />: <b>{this.state.attack[0]}</b>, &nbsp;
                                                <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(MOVEMENT)} alt="move" />: <b>{this.state.move[0]}</b>, &nbsp; 
                                                <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(RANGE)} alt="range" />: <b>{this.state.range[0]}</b> &nbsp;&nbsp;
                                        </div>
                                        </Fade>
                                        :
                                        null
                                }
                                {
                                    !this.state.collapseOpen ?
                                        
                                        this.state.extra[0].map((item) => {
                                            if ((Object(item) === item) && item.modifier != null) {
                                                return (
                                                    <Fade bottom duration={300} key={item.type}>
                                                    <div style={statsStyle}>
                                                        {item.type} {item.modifier} <img className="img-fluid MonsterTracker--StatIcon" src={getIcon(item.type)} alt={item.type} /> &nbsp;
                                                    </div>
                                                    </Fade>
                                                )
                                            } else if (Object(item) === item) {
                                                return (
                                                    <Fade bottom duration={300} key={item.type} >
                                                    <div style={statsStyle}>
                                                        {item.type} <img className="img-fluid MonsterTracker--StatIcon" src={getIcon(item.type)} alt={item.type} /> &nbsp;
                                                    </div>
                                                    </Fade>
                                                )
                                            } else {
                                                return (
                                                    <Fade bottom duration={300} key={item}>
                                                    <div  style={statsStyle}>
                                                        {item} &nbsp;
                                                    </div>
                                                    </Fade>
                                                )
                                            }
                                        })

                                        :
                                        null
                                }
                                </Row>
                                <Row>
                                {
                                    !this.state.collapseOpen ?
                                        <Fade bottom duration={300}>
                                        <div style={statsStyleElite}>
                                            &nbsp; HP: <b>{this.state.maxHP[1]}</b>, &nbsp;
                                            <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(ATTACK)} alt="attack" />: <b>{this.state.attack[1]}</b>, &nbsp;
                                            <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(MOVEMENT)} alt="move" />: <b>{this.state.move[1]}</b>, &nbsp;
                                            <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(RANGE)} alt="range" />: <b>{this.state.range[1]}</b> &nbsp;&nbsp;
                                        </div>
                                        </Fade>
                                        :
                                        null
                                }
                                {
                                    !this.state.collapseOpen ?
                                            this.state.extra[1].map((item) => {
                                                if ((Object(item) === item) && item.modifier != null) {
                                                    return (
                                                        <Fade bottom duration={300} key={item.type}>
                                                        <div  style={statsStyleElite}>
                                                            {item.type} {item.modifier} <img className="img-fluid MonsterTracker--StatIcon" src={getIcon(item.type)} alt={item.type} /> &nbsp;
                                                        </div>
                                                        </Fade>
                                                    )
                                                } else if (Object(item) === item) {
                                                    return (
                                                        <Fade bottom duration={300} key={item.type}>
                                                        <div style={statsStyleElite}>
                                                            {item.type} <img className="img-fluid MonsterTracker--StatIcon" src={getIcon(item.type)} alt={item.type} /> &nbsp;
                                                        </div>
                                                        </Fade>
                                                    )
                                                } else {
                                                    return (
                                                        <Fade bottom duration={300} key={item}>
                                                        <div  style={statsStyleElite}>
                                                            {item} &nbsp;
                                                        </div>
                                                        </Fade>
                                                    )
                                                }
                                            })
                                        
                                    :
                                        null
                                }
                                </Row>
                            </Col>
                            <Col md="4" sm="5" className="text-right">
                                <div>
                                    {this.state.monsterList.map((monster,i) => {
                                        return(
                                            <Button 
                                                key={i+1} 
                                                size="xs" 
                                                onClick={() => {this.toggleActive(i+1)}}
                                                className={
                                                    (this.state.monsterList[i].active ? "btn btn-secondary" : "btn btn-outline-secondary")
                                                }
                                            >
                                                {i+1}
                                            </Button>
                                        )
                                    })}

                                </div>
                            </Col>
                        </Row>
                    </CardHeader>
                    <Collapse isOpen={this.state.collapseOpen}>
                    <Container fluid>
                        <Row className="no-gutter">
                            <Col sm="2">
                                <img className="img-fluid rounded mx-auto d-block" id={"removeMonsterPopover-" + this.props.monsterType.replace(/\s+/g, '')} src={monsterImagesList[this.props.monsterType]} alt={this.props.monsterType} onClick={this.togglePopover}/>
                                <Popover placement="auto" isOpen={this.state.removePopoverOpen} target={"removeMonsterPopover-" + this.props.monsterType.replace(/\s+/g, '')} toggle={this.togglePopover}>
                                    <PopoverBody><Button color="danger" onClick={() => {this.props.removeMonster(this.props.monsterType)}}>Remove monster type</Button></PopoverBody>
                                </Popover>
                            </Col>
                            <Col sm="5">
                                <Row className="no-gutter">
                                    <Col md="6">
                                        <ListGroup>
                                            <ListGroupItem style={statsStyle}>HP: <b>{this.state.maxHP[0]}</b></ListGroupItem>
                                            <ListGroupItem style={statsStyle}>Attack <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(ATTACK)} alt="attack" />: <b>{this.state.attack[0]}</b></ListGroupItem>
                                            <ListGroupItem style={statsStyle}>Move <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(MOVEMENT)} alt="movement" />: <b>{this.state.move[0]}</b></ListGroupItem>
                                            <ListGroupItem style={statsStyle}>Range <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(RANGE)} alt="range" />: <b>{this.state.range[0]}</b></ListGroupItem>
                                        </ListGroup>
                                    </Col>
                                    <Col md="6">
                                        <ListGroup>
                                            {this.state.extra[0].map((item) => {
                                                if ((Object(item) === item) && item.modifier != null){
                                                    return (
                                                        <ListGroupItem key={item.type} style={statsStyle}>
                                                            {item.type} {item.modifier} <img className="img-fluid MonsterTracker--StatIcon" src={getIcon(item.type)} alt={item.type} />
                                                        </ListGroupItem>
                                                    )
                                                } else if (Object(item) === item) {
                                                    return(
                                                        <ListGroupItem key={item.type} style={statsStyle}>
                                                            {item.type} <img className="img-fluid MonsterTracker--StatIcon" src={getIcon(item.type)} alt={item.type} />
                                                        </ListGroupItem>
                                                    )
                                                } else {
                                                    return(
                                                        <ListGroupItem key={item} style={statsStyle}>
                                                            {item}
                                                        </ListGroupItem>
                                                    )
                                                }
                                            })}
                                        </ListGroup>
                                    </Col>
                                </Row>
                            </Col>

                            <Col sm="5">
                                <Row className="no-gutter">
                                    <Col md="6">
                                        <ListGroup>
                                            <ListGroupItem style={statsStyleElite}>HP: <b>{this.state.maxHP[1]}</b></ListGroupItem>
                                            <ListGroupItem style={statsStyleElite}>Attack <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(ATTACK)} alt="attack" />: <b>{this.state.attack[1]}</b></ListGroupItem>
                                            <ListGroupItem style={statsStyleElite}>Move <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(MOVEMENT)} alt="movement" />: <b>{this.state.move[1]}</b></ListGroupItem>
                                            <ListGroupItem style={statsStyleElite}>Range <img className="img-fluid MonsterTracker--StatIcon" src={iconForStat(RANGE)} alt="range" />: <b>{this.state.range[1]}</b></ListGroupItem>
                                        </ListGroup>
                                    </Col>
                                    <Col md="6">
                                        <ListGroup>
                                            {this.state.extra[1].map((item) => {
                                                if ((Object(item) === item) && item.modifier != null){
                                                    return (
                                                        <ListGroupItem key={item.type} style={statsStyleElite}>
                                                            {item.type} {item.modifier} <img className="img-fluid MonsterTracker--StatIcon" src={getIcon(item.type)} alt={item.type} />
                                                        </ListGroupItem>
                                                    )
                                                } else if (Object(item) === item) {
                                                    return(
                                                        <ListGroupItem key={item.type} style={statsStyleElite}>
                                                            {item.type} <img className="img-fluid MonsterTracker--StatIcon" src={getIcon(item.type)} alt={item.type} />
                                                        </ListGroupItem>
                                                    )
                                                } else {
                                                    return(
                                                        <ListGroupItem key={item} style={statsStyleElite}>
                                                            {item}
                                                        </ListGroupItem>
                                                    )
                                                }
                                            })}
                                        </ListGroup>
                                    </Col>
                                </Row>
                            </Col>

                        </Row>

                    </Container>
                    </Collapse>
                </Card>

                {/* individual monsters */}
                    <Row className="no-gutter">
                        {this.state.monsterList.map((monster,i) => {
                            if(this.state.monsterList[i].active){
                                return(
                                    <Col md="4" xs="6" key={i + 1}>
                                        <Card 
                                            className={((this.state.monsterList[i].rank === "elite" ? "card text-white bg-warning mb-3" : "card bg-light mb-3"))}
                                        >
                                            <CardHeader style={{ fontFamily: "PirataOne"}}>
                                                    <Row>
                                                        <Col md="7">
                                                            {this.props.monsterType} &nbsp; <b><font size="+2">{i+1}</font></b>
                                                        </Col>
                                                        <Col md="5">
                                                            <Button color="info" size="sm" onClick={() => { this.toggleRank(i + 1) }}>Rank</Button>&nbsp;
                                                            <Button color="danger" size="sm" onClick={() => { this.killMonster(i + 1) }}>Kill</Button>
                                                        </Col>
                                                    </Row>
                                            </CardHeader>
                                            <CardBody >
                                                    <Row>
                                                        <Col sm="6" xs="12">
                                                        <Progress style={{height:"30px"}} color="danger" value={this.state.monsterList[i].currentHP} max={this.state.monsterList[i].maxHP}><b>{this.state.monsterList[i].currentHP}</b></Progress>
                                                        </Col>
                                                        <Col sm="6" xs="12" className="text-center" >
                                                        <Button color="danger" size="sm" onClick={() => { this.changeHP(i + 1, -1) }}>-</Button> &nbsp;&nbsp;
                                                            <StatusPopover 
                                                                text={"S"} 
                                                                placement="auto" 
                                                                id={"Statuses-" + this.props.monsterType.replace(/\s+/g, '') + "-" + (i + 1)} 
                                                                toggleStatus={this.toggleStatus} 
                                                                clearStatuses={this.clearStatuses}
                                                                statusList={this.state.monsterList[i].statuses}
                                                                monsterType={this.props.monsterType}
                                                                monsterNumber={i + 1} /> 
                                                                
                                                                &nbsp;&nbsp;
                                    
                                                            <Button color="success" size="sm" onClick={() => { this.changeHP(i + 1, 1) }}>+</Button>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        {Object.keys(this.state.monsterList[i].statuses).map((status) => {
                                                            if(this.state.monsterList[i].statuses[status]){
                                                                return(
                                                                    <div key={status}>
                                                                        <Fade>
                                                                        <img className="img-fluid MonsterTracker--StatusEffectIcon" src={getIcon(status.toUpperCase())} alt={status} onClick={() => {this.toggleStatus(i+1,status)}} style={{cursor:"pointer"}}/> 
                                                                        </Fade>
                                                                    </div>
                                                                );
                                                            } else{
                                                                return(null);
                                                            }
                                                        })}

                                                    </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                )
                            } else {
                                return(null);
                            }
                        })}
                    </Row>

            </div>
        )
    }
}

export default MonsterContainer;


// WEBPACK FOOTER //
// ./src/components/MonsterContainer.js